import * as Yup from 'yup'

import { COUNTRY_ID } from '../../fields'

export const validationSchema = Yup.object({
  [COUNTRY_ID]: Yup.string().required('Country of operation is required')
})
